import PropTypes from 'prop-types';

import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import styles from "./Loader.module.css";

const Loader = ({ showMsg = false }) => {
  return (
    <div className={styles.loader}>
      <div className={`${styles.loaderContent} ${showMsg ? styles.hasBox : ''}`}>

        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
          <CircularProgress
            variant="determinate"
            sx={{ color: '#E2E8F0' }}
            size={56}
            thickness={4.5}
            value={100}
          />
          <CircularProgress
            variant="indeterminate"
            disableShrink
            sx={{
              color: '#0B2545',
              animationDuration: '600ms',
              position: 'absolute',
              left: 0,
              [`& .MuiCircularProgress-circle`]: {
                strokeLinecap: 'round',
              },
            }}
            size={56}
            thickness={4.5}
          />
        </Box>

        {showMsg && (
          <p>
            <strong>Generating Proposal...</strong>
            <br />
            It takes up to 90 seconds to generate the proposal.
            Please wait while it's being processed.
          </p>
        )}

      </div>
    </div>
  );
};

Loader.propTypes = {
  showMsg: PropTypes.bool,
};

export default Loader;